<template>
  <div class="nutrition-bar">
    <div class="header">
      {{ title }}
      <div class="status" :class="statusClass">
        <span class="icon">{{ statusIcon }}</span>
        <span class="text">{{ statusText }}</span>
        <span>
          <a href="#" class="infos" title="Mes apports en détail">?</a>
        </span>
      </div>
    </div>

    <div class="bar-container">
      <div class="bar-background"></div>
      <div
        class="bar-fill"
        :class="{ good: isGreen, bad: !isGreen }"
        :style="fillStyleInternal"
      >
        <span class="percentage-label">
          <template v-if="isEnergy">
            {{ roundedTarget }} cal/j ({{ percentage }}%)
          </template>
          <template v-else-if="hasTarget">
            {{ percentage }}%
          </template>
          <template v-else>
            {{ actual }} {{ unit }}
          </template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenteredNutritionBar',
  props: {
    name: String,
    title: String,
    unit: String,
    actual: Number,
    target: Number,
    min: Number,
    max: Number,
  },
  data() {
    return {
      fillStyleInternal: {
        width: '0%',
        left: '0%',
      },
    };
  },
  computed: {
    isEnergy() {
      return this.name === "energy"; // le titre "Énergie"
    },
    roundedTarget() {
      if (!this.target) return 0;

      // arrondi demandé :
      return Math.round(this.target);
    },

    hasTarget() {
      return this.target !== null && this.target !== undefined;
    },

    percentage() {
      if (!this.target) return 0;
      return Math.round((this.actual / this.target) * 100);
    },

    isGreen() {
      if (this.max != null && this.actual > this.max) return false;
      if (this.min != null && this.actual < this.min) return false;
      return true;
    },

    fillStyle() {
      if (this.hasTarget) {
        const ratio = this.actual / this.target;
        return { width: `${ratio * 100 / 6}%` };
      }
      return { width: "0%" };
    },

    statusText() {
      if (!this.isGreen) {
        if (this.max !== null && this.actual > this.max) return "Trop haut";
        if (this.min !== null && this.actual < this.min) return "Trop bas";
      }
      return "OK";
    },

    statusIcon() {
      if (!this.isGreen) {
        if (this.max !== null && this.actual > this.max) return "🔺";
        if (this.min !== null && this.actual < this.min) return "🔻";
      }
      return "✅";
    },

    statusClass() {
      return this.isGreen ? "good" : "bad";
    },
  },

  watch: {
    fillStyle: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.fillStyleInternal = { ...newVal };
          }, 10);
        });
      },
    },
  },
};
</script>

<style scoped>
.nutrition-bar {
  margin-bottom: 15px;
  font-family: sans-serif;
}

.header {
  display: flex;
  font-weight: bold;
  margin-bottom: 6px;
  align-items: center;
}

.status {
  display: flex;
  align-items: center;
  margin-left: 10px;
  font-size: 14px;
}

.status.good {
  color: #2e7d32;
}

.status.bad {
  color: #c62828;
}

.bar-container {
  position: relative;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.bar-fill {
  position: absolute;
  height: 100%;
  transition: width 0.8s ease-in-out;
}

.bar-fill.good {
  background-color: #2e7d32;
}

.bar-fill.bad {
  background-color: #c62828;
}

.percentage-label {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: white;
  font-weight: 600;
}
</style>
